module.exports = __webpack_public_path__ + "distVue/img/error.50a20cde.jpg";